import { Controller } from '@hotwired/stimulus';
import { addMilliseconds, differenceInMilliseconds, format, parseISO } from 'date-fns';

const differenceLimit = 30000;

export default class ServerTimeController extends Controller {
  static values = {
    now: String
  };

  static targets = [
    'currentTime'
  ];

  connect() {
    const timestamp        = performance.now();
    const delta            = differenceInMilliseconds(parseISO(this.nowValue), new Date());
    const clientOriginTime = addMilliseconds(new Date(), delta);
    const callback = () => {
      const newCurrentTime  = addMilliseconds(clientOriginTime, (performance.now() - timestamp));
      const difference = differenceInMilliseconds(
        newCurrentTime,
        addMilliseconds(new Date(), delta),
      );

      if (Math.abs(difference) > differenceLimit) {
        clearInterval(this.timer);
        window.location.reload();
      } else {
        this.currentTime = newCurrentTime;

        if (this.hasCurrentTimeTarget) {  
          this.currentTimeTarget.textContent = format(this.currentTime, 'HH:mm:ss');
        }

        this.dispatch('tick', {
          detail: { now: newCurrentTime },
        });
      }
    };

    this.currentTime = clientOriginTime;
    this.timer = setInterval(callback, 1000);

    if (this.hasCurrentTimeTarget) {
      this.currentTimeTarget.textContent = format(this.currentTime, 'HH:mm:ss');
    }
  }

  disconnect() {
    clearInterval(this.timer);
  }
}
